import classes from './Col.css'
import BaseComponent from '../../BaseComponent'

export default BaseComponent(classes.root)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Layout/Col/Col.js